module.exports = __webpack_public_path__ + "img/am.1e37a8c0.svg";